import { MeasurementResult, MeasurementRequirement, InputMeasurementCollection, CategoricMeasurement } from "./Measurements/Measurement"
import { TaskData, getMetadataForMeasurement, getMetadataForResult } from "./Tasks/Task"

/**
 * The order of the EKG leads.
 */
export const EKG_LEAD_ORDER = [
    'I',
    'II',
    'III',
    'aVR',
    'aVL',
    'aVF',
    'V1',
    'V2',
    'V3',
    'V4',
    'V5',
    'V6',
]

/**
 * Orders the measurement results by the EKG lead order.
 * @param result The measurement results to order.
 * @param taskData The task data.
 * @returns The ordered measurement results.
 */
export function orderResultByLead(result: MeasurementResult[], taskData: TaskData): MeasurementResult[] {
    return result.sort((a, b) => {
        const aLead = getMetadataForResult(a, taskData)?.lead
        const bLead = getMetadataForResult(b, taskData)?.lead

        if (!aLead || !bLead) {
            return 0
        }

        return EKG_LEAD_ORDER.indexOf(aLead) - EKG_LEAD_ORDER.indexOf(bLead)
    })
}

/**
 * Orders the measurement requirements by the EKG lead order.
 * @param requirements The measurement requirements to order.
 * @returns The ordered measurement requirements.
 */
export function orderMeasurementRequirementsByLead(requirements: MeasurementRequirement[]): MeasurementRequirement[] {
    return requirements.sort((a, b) => {
        if(a.key === 'calibration') {
            return -1
        } else if(b.key === 'calibration') {
            return 1
        }

        return EKG_LEAD_ORDER.indexOf(a.metadata.lead) - EKG_LEAD_ORDER.indexOf(b.metadata.lead)
    })
}

/**
 * Gets the categoric measurement with the given key from the collection, if it exists.
 * @param key The key of the measurement to get.
 * @param inputs The collection of measurements to search in.
 * @returns The categoric measurement with the given key, if it exists.
 */
export function getCategoricMeasurementFromCollection(key: string, inputs: InputMeasurementCollection): CategoricMeasurement | undefined {
    return inputs.find(i => i.key === key) as CategoricMeasurement;
}